import { Link } from 'react-router-dom';
import { categories } from '@/mocks/categories';

const colorMap: Record<string, string> = {
  primary: 'bg-primary-100 text-primary-700 group-hover:bg-primary-500 group-hover:text-white',
  accent: 'bg-accent-100 text-accent-700 group-hover:bg-accent-500 group-hover:text-white',
  secondary: 'bg-secondary-100 text-secondary-700 group-hover:bg-secondary-500 group-hover:text-white',
};

const iconBgMap: Record<string, string> = {
  primary: 'bg-primary-100/80 text-primary-600 group-hover:bg-white/20 group-hover:text-white',
  accent: 'bg-accent-100/80 text-accent-600 group-hover:bg-white/20 group-hover:text-white',
  secondary: 'bg-secondary-100/80 text-secondary-600 group-hover:bg-white/20 group-hover:text-white',
};

export default function CategorySection() {
  return (
    <section className="max-w-7xl mx-auto px-4 md:px-6 py-16">
      <div className="mb-8">
        <div className="flex items-center gap-3 mb-2">
          <div className="w-1 h-5 bg-accent-500 rounded-full"></div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950">
            分类浏览
          </h2>
        </div>
        <p className="text-sm text-foreground-500">按你想看的类型，精准吃瓜不迷路</p>
      </div>

      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-4">
        {categories.map((cat) => (
          <Link
            key={cat.id}
            to={`/category/${cat.slug}`}
            className={`group flex flex-col items-center gap-3 p-5 rounded-lg border border-background-200/70 transition-all duration-300 ${colorMap[cat.color] || colorMap.primary}`}
          >
            <div className={`w-12 h-12 rounded-full flex items-center justify-center transition-all duration-300 ${iconBgMap[cat.color] || iconBgMap.primary}`}>
              <i className={`${cat.icon} text-xl`}></i>
            </div>
            <span className="text-sm font-bold whitespace-nowrap">{cat.name}</span>
            <span className="text-xs text-center leading-relaxed opacity-70 line-clamp-2 hidden md:block">
              {cat.description}
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}